const CHECK_INTERVAL = 5 * 60 * 1000
const RELOADED_KEY = 'app_reloaded_for_version'

async function fetchLatestVersion(): Promise<string | null> {
    try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
        if (!res.ok) return null
        const data = await res.json()
        return typeof data?.version === 'string' ? data.version : null
    } catch {
        return null
    }
}

async function checkForNewVersion() {
    const latest = await fetchLatestVersion()
    if (!latest || latest === __APP_VERSION__) return
    // Guard against a reload loop if the server keeps serving a cached index.html
    if (sessionStorage.getItem(RELOADED_KEY) === latest) return
    sessionStorage.setItem(RELOADED_KEY, latest)
    window.location.reload()
}

export function startVersionCheck() {
    // if (!import.meta.env.PROD) return

    // A lazy chunk failed to load (old chunk deleted by a new deploy) — reload to get the new build
    window.addEventListener('vite:preloadError', (event) => {
        event.preventDefault()
        window.location.reload()
    })

    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) checkForNewVersion()
    })
    setInterval(checkForNewVersion, CHECK_INTERVAL)
    checkForNewVersion()
}
